// Shared money state — display is fixed to EUR (the user's preferred currency for car business).
// We keep the BNR rate available so input forms can convert LEI → EUR at submission.
const _state = { currency: "EUR", rate: 1 };

export function getMoneyState() {
  return _state;
}

export function setMoneyRate(r) {
  _state.rate = r;
}

export function format(value) {
  const eur = Number(value || 0);
  return new Intl.NumberFormat("ro-RO", { maximumFractionDigits: 0 }).format(eur) + " €";
}

/**
 * Return the lei amount for an expense/fixed-cost doc.
 *   - If the user originally typed the amount in RON, return that fixed value
 *     (no re-conversion → immune to BNR fluctuations).
 *   - Otherwise, convert the stored EUR amount using the current rate.
 */
export function displayLei(doc, currentRate) {
  if (!doc) return 0;
  if (doc.original_currency === "RON" && doc.original_amount != null) {
    return Number(doc.original_amount);
  }
  return Math.round(Number(doc.amount || 0) * Number(currentRate || 0));
}

export function formatLei(n) {
  return new Intl.NumberFormat("ro-RO").format(Math.round(Number(n || 0))) + " lei";
}
